<template>
    <div>

        <!-- InfoPOPUP -->
        <v-layout  row justify-center>
            <v-dialog v-model="mustShowGeneralQuestionsAreNotAllAnsweredPopup" content-class="border-color-invisible" persistent max-width="600" id="close-popup">
                <v-card class="no-padding not-allGenQAnsw-popup info-popup">
                    <v-card-title class="headline bg-color-primary">
                        <span class="font-weight-regular warn color-on-primary-text">{{ text('api.pro.incomplete.pretriage.popup.title') }}</span>
                        <span @click="closeInfoPopup()" id="btnGenQBotAllAnsweredPopupClose" class="float-right cursor-pointer">
                            <close-icon :svg-fill-class="'svg-on-primary-color'" />
                        </span>
                    </v-card-title>
                    <v-card-text class="padding-s">

                        <div>
                            <p>
                                {{ text('api.pro.incomplete.pretriage.popup.description') }}
                            </p>
                        </div>

                    </v-card-text>
                    <v-card-actions class="component-bg-color">
                        <v-spacer></v-spacer>
                        <v-btn flat @click="closeInfoPopup()" id="btnGenQBotAllAnsweredPopupCancel" class="cancel">{{ text('api.button.cancel') }}</v-btn>
                        <v-btn flat @click="goToMainSymptomPage()" id="btnGenQBotAllAnsweredPopupContinue" class="color-on-primary-text bg-color-primary-important no-border" >{{ text('api.button.continue') }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

    </div>
</template>

<!-- ################################################################## -->

<script>
import {mapGetters} from 'vuex';
import CloseIcon from "../svg/shared/closeIcon";

export default {
        name: 'GeneralQuestionAreNotAllAnsweredPopup',
        components: {CloseIcon},
        computed: {
            ...mapGetters({
                mustShowGeneralQuestionsAreNotAllAnsweredPopup: 'AssessmentStartStore/getGeneralQuestionAreNotAllAnsweredPopup',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue'
            })
        },

        mounted() {

        },

        methods: {

            closeInfoPopup() {
                this.$store.commit('AssessmentStartStore/setGeneralQuestionAreNotAllAnsweredPopup', false);
            },

            goToMainSymptomPage() {
                // Go to Choose Main Symptom page.
                if(this.patientProfileStatus !== false) {
                    this.$store.dispatch("AssessmentStartStore/confirmNotAllGenQAreAnswered");
                }
            },

            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***      BEGIN CODE         ***
             *******************************/

            handleKeyDowns(event) {

                if (this.mustShowGeneralQuestionsAreNotAllAnsweredPopup === false) {
                    return;
                }

                switch (event.keyCode) {

                    // Escape => (Cancel button)
                    case 27:
                        this.closeInfoPopup();
                        break;

                    // Enter
                    case 13:
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {
                            // CTRL + Enter = Continue
                            this.$parent.shortcutNav.isKeyboardNav = true;
                            this.goToMainSymptomPage();
                        }
                        break;

                }
            }

        },


        created: function() {
            window.addEventListener('keydown', this.handleKeyDowns);
        },

        destroyed: function() {
            window.removeEventListener('keydown', this.handleKeyDowns);
        }

    }
</script>




// WEBPACK FOOTER //
// src/common/components/shared/GenQAreNotAllAnswPopup.vue